import { logout as logoutApi } from "./apis/logout";
import { getCookieDomain } from "../utils/config";
import { removeCookies } from "../utils/cookieManager";
import { emit, triggerError } from "../utils/eventManager";
import { sendNewRelicEvent } from "../utils/newRelicEvents";
import { getBroadcastChannel } from "../utils/broadcastChannel";
export { logout };
async function logout(auth0) {
  if (getCookieDomain() && !auth0) {
    removeCookies(getCookieDomain());
  }
  try {
    sendNewRelicEvent({
      EventName: 'logout_start'
    });
    await logoutApi();
    sendNewRelicEvent({
      EventName: 'logout_success'
    });
    var channel = getBroadcastChannel();
    if (channel) {
      channel.postMessage({
        action: 'logout'
      });
    }
    emit('logout.success');
  } catch (e) {
    sendNewRelicEvent({
      EventName: 'logout_failed',
      error: e
    });
    triggerError('logout', e);
  }
}